import React, { SVGProps } from "react";

export default function ClipboardIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width={15} height={17} {...props}>
      <path
        d="M14.53 2.19L12.791.466A1.614 1.614 0 0011.656 0H5.893a1.6 1.6 0 00-1.607 1.594v1.593H1.607A1.6 1.6 0 000 4.782v10.625A1.6 1.6 0 001.607 17h7.5a1.6 1.6 0 001.607-1.594v-1.594h2.679A1.6 1.6 0 0015 12.22V3.316c0-.422-.17-.828-.47-1.127zm-2.744-1.111c.094.023.18.071.249.14l1.737 1.722a.526.526 0 01.14.247h-2.126v-2.11zM9.643 15.406c0 .293-.24.531-.536.531h-7.5a.534.534 0 01-.536-.53V4.78c0-.293.24-.531.536-.531h2.679v7.969a1.6 1.6 0 001.607 1.594h3.75v1.593zm4.286-3.187c0 .293-.24.531-.536.531h-7.5a.534.534 0 01-.536-.531V1.594c0-.293.24-.532.536-.532h4.821v2.391c0 .438.362.797.804.797h2.41v7.969z"
        fill="#0071BB"
        fillRule="nonzero"
      />
    </svg>
  );
}
